'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require('../../lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'button': 'Primary__button___3Jloz',
  'small': 'Primary__small___1mUB3',
  'medium': 'Primary__medium___GQjew',
  'large': 'Primary__large___27Jt8'
};

var PrimaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
PrimaryButton.displayName = 'PrimaryButton';
exports.default = PrimaryButton;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Button/Primary.js
// module id = 696
// module chunks = 4 5 8 9 14